<template>
  <main-container class="account-container" title="サンプルデータ" :showFooter="false">
    <div slot="main-content">
      <div class="credit-label-container"><h2>2値分類</h2></div>
      <div class="credit-item-container">
        <p class="credit-item">
          <a href="https://s3-ap-northeast-1.amazonaws.com/dev.public.skyfox.sxi.co.jp/samples/%E6%96%B0%E5%95%86%E5%93%81%E3%82%B3%E3%83%B3%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E4%BA%88%E6%B8%AC_%E5%AD%A6%E7%BF%92%E7%94%A8.csv">
            新商品コンバージョン予測_学習用</a><br>
          <a href="https://s3-ap-northeast-1.amazonaws.com/dev.public.skyfox.sxi.co.jp/samples/%E6%96%B0%E5%95%86%E5%93%81%E3%82%B3%E3%83%B3%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E4%BA%88%E6%B8%AC_%E4%BA%88%E6%B8%AC%E7%94%A8.csv">
            新商品コンバージョン予測_予測用</a><br>
          <span class="credit-source">ある新商品を販促する際にコンバージョンするかどうかを予測します。</span>
        </p>
      </div>
    </div>
  </main-container>
</template>

<script>

export default {
  name: 'SamplesView'
}
</script>

<style scoped>
.credit-label-container {
  padding: 25px 40px;
  background: #fff;
}
.credit-label-container > h2 {
  font-size: 1.5rem;
  font-weight: normal;
  padding: 0;
}
.credit-item-container {
  padding: 25px 40px;
  background: #f1f5f8;
  border-bottom: 1px solid #c0d5ef;
}
.credit-item {
  margin: 0 0 10px 0;
}
.credit-item > .credit-source {
  font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/account/samples.vue